export default function (editor) {
  editor.Panels.removeButton('options', 'export-template')

  const pfx = editor.getConfig().stylePrefix
  const modal = editor.Modal
  const cmdm = editor.Commands
  const pnm = editor.Panels
  const container = document.createElement('div')
  const btnSave = document.createElement('button')
  const codeEditor = { html: undefined, css: undefined, element: undefined }

  btnSave.innerHTML = 'Save'
  btnSave.className = pfx + 'btn-prim ' + pfx + 'btn-import'
  btnSave.onclick = function () {
    editor.DomComponents.getWrapper().set('content', '')
    editor.setComponents(codeEditor.html.editor.getValue().trim())
    editor.setStyle(codeEditor.css.editor.getValue().trim())
    modal.close()
  }

  function buildEditor (codeName, theme, label) {
    const input = document.createElement('textarea')
    const codeMirror = editor.CodeManager.getViewer('CodeMirror')

    const model = codeMirror.clone().set({
      readOnly: 0,
      label,
      codeName,
      theme,
      input
    })

    const $el = new editor.CodeManager.EditorView({
      model,
      config: editor.CodeManager.getConfig()
    }).render().$el

    model.init(input)

    return { model, $el }
  }

  cmdm.add('edit-code', {
    run: function (editor, sender) {
      sender && sender.set('active', 0)
      modal.setTitle('Edit code')

      if (!codeEditor.html || !codeEditor.css) {
        const htmlEditor = buildEditor('htmlmixed', 'hopscotch', 'HTML')
        const cssEditor = buildEditor('css', 'hopscotch', 'CSS')
        codeEditor.html = htmlEditor.model
        codeEditor.css = cssEditor.model
        container.appendChild(htmlEditor.$el[0])
        container.appendChild(cssEditor.$el[0])
        container.appendChild(btnSave)
        codeEditor.element = container
      }

      codeEditor.html.setContent(editor.getHtml())
      codeEditor.css.setContent(editor.getCss({ avoidProtected: true }))
      modal.open({ title: 'Code', content: codeEditor.element })
      codeEditor.html.refresh()
      codeEditor.css.refresh()
    }
  })

  pnm.addButton('options',
    [
      {
        id: 'edit',
        className: 'fa fa-code',
        command: 'edit-code',
        attributes: {
          title: 'Edit Code'
        }
      }
    ]
  )
}
